(ns dashboard.views.answer-bank.view
  (:require [clojure.string :as str]
            [dashboard.common :refer [format-date]]
            [dashboard.components.answer :as answer]
            [dashboard.components.answer-options :refer [AnswerOptions]]
            [dashboard.components.breadcrumbs :refer [breadcrumbs]]
            [dashboard.components.copy :refer [CopyToClipboard]]
            [dashboard.components.paginated-list.events :as list-events]
            [dashboard.components.paginated-list.view :as paginated-list]
            [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.html :as html]
            [dashboard.subs :as common-subs]
            [dashboard.utils :as utils]
            [dashboard.views.analysis.common :as analysis]
            [dashboard.views.answer-bank.config :as config]
            [dashboard.views.answer-bank.events :as events]
            [dashboard.views.answer-bank.subs :as subs]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]))

(def controllers [{:start (fn []
                            (rf/dispatch [::events/get-answer-bank])
                            (analysis.db/get-structured-analyses false)
                            (analysis.db/get-applied-analyses false))}])

(def column-config
  [{:label             "Source"
    :id                :source
    :editable-key      :source
    :editable-disabled true
    :sort-key          (fn [{:keys [questionnaire-name questionnaire-filename questionnaire-url]}]
                         (or questionnaire-name questionnaire-filename questionnaire-url))
    :render            (fn [{:keys [questionnaire-name questionnaire-filename questionnaire-url questionnaire-id]}]
                         [:a.text-layout
                          {:href (rfe/href :route.view/questionnaire-question-list
                                           {:questionnaire-id questionnaire-id})}
                          (or questionnaire-name questionnaire-filename questionnaire-url)])}
   {:label             "Created"
    :id                :created
    :editable-key      :created
    :editable-disabled true
    :editable-format   format-date
    :sort-key          :created
    :render            (fn [{:keys [created]}]
                         [:div
                          (format-date created)])}
   {:label              "Question"
    :id                 :question
    :editable-key       :question
    :editable-validator (complement str/blank?)
    :sort-key           #(utils/lower-case (:question %))
    :render             (fn [{:keys [question display-name]} _index]
                          [:span
                           display-name
                           " "
                           (html/as-hiccup-with-anchors question)])}
   {:label              "Response"
    :id                 :response
    :editable-key       :response
    :editable-validator (complement str/blank?)
    :sort-key           #(utils/lower-case (:response %))
    :render             (fn [{:keys [response question-options]} _index]
                          [:div
                           (when-let [options (seq question-options)]
                             [AnswerOptions {:options options}])
                           (let [tag-class (answer/response-tag-class response)]
                             (if tag-class
                               [:span.tag {:class tag-class}
                                response]
                               [:span
                                (html/as-hiccup-with-anchors response)
                                [CopyToClipboard "Response" response]]))])}
   {:label        "Comment"
    :id           :comment
    :editable-key :comment
    :sort-key     #(utils/lower-case (:comment %))
    :render       (fn [{:keys [comment]} _index]
                    [:span
                     (html/as-hiccup-with-anchors comment)
                     [CopyToClipboard "Comment" comment]])}
   {:label        "Unstructured Analysis"
    :id           :unstructured-analysis
    :editable-key :analysis
    :sort-key     :analysis-content
    :render       (fn [{:keys [analysis]}]
                    [:span
                     (html/as-hiccup-with-anchors analysis)])}
   {:label    "Applied Analysis"
    :id       :applied-analyses
    :sort-key (fn [item]
                (mapv :construct-id (:applied-analyses item)))
    :render   (fn [{:keys [applied-analyses questionnaire-id question-id answer-id question display-name
                           response comment
                           questionnaire-name questionnaire-filename]}]
                [:f> analysis/applied-analysis-column
                 applied-analyses
                 questionnaire-id
                 {:id              question-id
                  :content         question
                  :display-name    display-name
                  :selected-answer {:response response
                                    :comment  comment}
                  :questionnaire   (or questionnaire-name questionnaire-filename)}
                 answer-id])}
   {:id      :actions
    :classes ["is-narrow"]
    :label   ""
    :render  (fn [{:keys [questionnaire-type question-id]}]
               (when (= questionnaire-type "one-off")
                 [:button.button.is-danger.is-light.is-rounded.is-small
                  {:title    "Delete answer"
                   :on-click #(rf/dispatch [::events/try-delete-question-answer question-id])}
                  [:span.icon>i.fas.fa-trash]]))}])

(defn list-view []
  (let [heading @(rf/subscribe [::common-subs/view.page-heading])
        view-config-path [:view/answer-bank]]
    [:div
     [breadcrumbs {:items (config/breadcrumbs)}]
     [:div.section {:style {:overflow-x "auto"}}
      [:p.title.is-3 heading]
      [:f> paginated-list/paginated-list
       {:view-config-path view-config-path
        :header-content [:a.button.is-secondary.mx-3.is-rounded
                         {:on-click #(rf/dispatch [::list-events/enable-editable-row
                                                   view-config-path
                                                   {:source "One-off"
                                                    :created (js/Date.)
                                                    :question ""
                                                    :response ""
                                                    :comment ""
                                                    :analysis ""}])}
                         [:span.icon.mr-1>i.fas.fa-plus]
                         "Add entry"]
        :columns column-config
        :on-save-editable-row #(rf/dispatch [::events/create-answer view-config-path %])
        :search-enabled true}
       {:items-sub [::subs/data]
        :loading-sub [::subs/loading]
        :data-filter (fn [search-query row]
                       (utils/match-search-query
                        search-query
                        (fn [query-word]
                          (or (utils/str-includes-icase? (:question row) query-word)
                              (utils/str-includes-icase? (or (-> row :answer-data :additional-information)
                                                             (-> row :answer-data :comment)) query-word)
                              (utils/str-includes-icase? (-> row :answer-data :response) query-word)
                              (utils/str-includes-icase? (-> row :analysis-content) query-word)))))
        :default-sort-keyfn :created
        :default-sort-order :desc}]]]))
